import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-satisfaction-star",
  "use": "icon-satisfaction-star-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-satisfaction-star\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.6807 24.8643C15.098 24.558 14.402 24.558 13.8193 24.8643L9.07932 27.3563C7.61207 28.1276 5.89721 26.8817 6.17743 25.2479L7.08268 19.9698C7.19396 19.3211 6.97886 18.6591 6.50749 18.1996L2.67276 14.4616C1.48572 13.3046 2.14074 11.2886 3.78118 11.0502L9.08066 10.2802C9.73208 10.1855 10.2952 9.77639 10.5865 9.18611L12.9565 4.38397C13.6902 2.89748 15.8098 2.89748 16.5435 4.38397L18.9135 9.18611C19.2048 9.77639 19.7679 10.1855 20.4193 10.2802L25.7188 11.0502C27.3593 11.2886 28.0143 13.3046 26.8272 14.4616L22.9925 18.1996C22.5211 18.6591 22.306 19.3211 22.4173 19.9698L23.3226 25.2479C23.6028 26.8817 21.8879 28.1276 20.4207 27.3562L15.6807 24.8643Z\" fill=\"#C8D3DF\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/satisfaction-star.svg
// module id = M8oE
// module chunks = 6 7